import React, { useEffect } from "react";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { useDispatch } from "react-redux";
import { push } from "redux-first-history";
import CustomButton from "./CustomButton";
import { logout } from "../store/actions/auth";
import { useSelector } from "react-redux";
import { RootState } from "../store/index";

const LogoutModal = ({ show, setShow }: any) => {
  const dispatch = useDispatch();
  const isAuthenticated = useSelector(
    (state: RootState) => state.auth.isAuthenticated
  );

  // Move to login page when flag turns false
  useEffect(() => {
    if (!isAuthenticated) {
      dispatch(push("/"));
    }
  }, [isAuthenticated, dispatch]);

  return (
    <Modal
      disableAutoFocus
      open={show}
      onClose={() => setShow(false)}
      aria-labelledby="logut-modal"
      className={'modal-container'}
    >
      <div className={'modal-paper'}>
        <Box component="h3" m={1} className={'modal-title'}>
          Logout
        </Box>
        <p className={'modal-sub-title'}>Are you sure you want to log out?</p>
        <Grid
          container
          className={'modal-button-container'}
        >
          <CustomButton
            variant="outlined"
            disableElevation={false}
            label={"no"}
            onClick={() => setShow(false)}
            buttonSize={'modal-button-left'}
          />
          <CustomButton
            variant="contained"
            disableElevation={true}
            label={"yes"}
            onClick={() => {
              dispatch(logout());
              setShow(false);
            }}
          />
        </Grid>
      </div>
    </Modal>
  );
};

export default LogoutModal;
